// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-modal-icon-close[data-v-6151665a]{position:absolute;top:15px;right:15px;cursor:pointer}.btn-avatar[data-v-6151665a]{border:1px solid #929292;border-radius:.625rem}", ""]);
// Exports
module.exports = exports;
